// combatpro/shell/ReadableSelect.js
//
// Combat PRO - ReadableSelect. A native <select> whose CURRENT VALUE is always fully
// readable. A browser draws a select's chosen option on one line and clips it with
// an ellipsis when the control is narrower than the text, which hid long encounter
// and monster names in the shell. Here the visible face is an ordinary block that
// wraps onto as many lines as the value needs, and the real native select sits
// transparently over it, so clicking / tapping / keyboard still open the platform
// picker and every existing onChange, value and id behaves exactly as before.
// Presentation lives in combatProTheme.css (.cp-rsel). No optional chaining, no
// nullish coalescing, no em dash.

import React from 'react';

function ReadableSelect(props) {
  var faceClass = 'cp-rsel-face' + (props.faceClassName ? (' ' + props.faceClassName) : '');
  return (
    <div className={'cp-rsel' + (props.className ? (' ' + props.className) : '')}>
      <span className={faceClass} aria-hidden="true">{props.faceText}</span>
      <select
        id={props.id}
        className="cp-rsel-native"
        value={props.value}
        onChange={props.onChange}
        aria-label={props.ariaLabel}
        title={props.faceText}
      >
        {props.children}
      </select>
    </div>
  );
}

export default ReadableSelect;
